<template>
  <div class="row">
    <div class="col-12">
      <ibox :title="'Przymierzalnia'">
        <template slot="content" slot-scope="{ setLoading }">
          <list-products @loading="setLoading"> </list-products>
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import ListProducts from '@/components/VNFR/ProductInCategory/ListProducts.vue'

export default {
  name: 'ProductsInCategoriesList',
  components: {
    Ibox,
    ListProducts
  },
  data() {
    return {}
  }
}
</script>
